import * as types from '../actions/actionTypes';

const defaultState = {
  network: null,
  account: null,
  balance: null,
  kat: null,
  txId: null,
  visible: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.CONNECT_WALLET_SUCCESS:
      return { ...state, ...action.data };
    case types.DISCONNECT_WALLET_SUCCESS:
      return { ...state, ...action.data };
    case types.WATCH_INFO_SUCCESS:
      return { ...state, ...action.data };
    case types.WATCH_INFO_FAIL:
      return { ...state, ...action.data };
    case types.TRANSFER_KAT_SUCCESS:
      return { ...state, ...action.data };
    case types.TRANSFER_KAT_FAIL:
      return { ...state, ...action.data };
    case types.SET_ACCOUNT_WALLET_SUCCESS:
      return { ...state, ...action.data };
    default:
      return state;
  }
};
